module.exports = __webpack_public_path__ + "static/media/blueNote.f1ac0799.svg";